export default __webpack_public_path__ + "static/media/Group38237.559db30a.png";